<template>
  <div id="fire">
    <div class="firstPart">
      <div class="topPart">
        <h2 class="title">智慧消防</h2>
        <div class="intro">
          消防报警主机通常负责一个区域的烟感、手报等设备报警信息展示。
          在位置比较临近的情况下，也可以多台主机组网。但遇到跨建筑、距离远、不同品牌主机等情况，主机间数据难以互通。
          通过增加信息传输设备，采集消防报警主机信号，实现跨区域、跨品牌主机间数据互联互通，让相关人员不仅在消控室，也可以在任意地点实时查看每台主机信息。
        </div>
      </div>
      <el-row :gutter="50" class="elRow">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" align="center">
          <img
            src="../../../assets/img/product/bdxt.png"
            alt=""
            class="leftImg"
          />
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <div class="rightInfo">
            <div
              v-for="(item, index) in fireType"
              :key="index"
              class="typeItem wow animate__zoomIn"
              :class="{
                marginLeft: index == 2 || index == 6 ? true : false,
              }"
            >
              <!-- @click="changeSlider(index)" -->
              <img :src="item.icon" alt="" />
              <div class="typeName">{{ item.name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="middlePart">
      <div class="topPart">
        <div class="title">多种设备系统类型分场景展示</div>
      </div>
      <div class="contentImg">
        <img src="../../../assets/img/product/sucai.png" alt="" srcset="">
      </div>
    </div>
    <div class="lastPart">
      <div class="topPart">
        <div class="title">消防一张图</div>
        <div class="intro">
          铁辰智慧消防系统应用地理信息技术（GIS）,帮助用户直观查看建筑分层 /
          区域结构 、 设备点位 、视频分布 、 设施间位置关系等情 况
          。支持按用户需求 ， 现场采集信息 、 绘制地图 ，支持多类型地图集成
          ，支持各类设备设施标注 。
        </div>
      </div>
      <div class="imgBox">
        <Viewer :srcArr="srcListArr" />
      </div>
    </div>
    <Common/>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { WOW } from "wowjs";
import Viewer from "../../../components/viewer/viewer.vue";
import Common from "./common.vue";
export default {
  props: {},
  data() {
    return {
      swiperOption: {
        loop: false,
        autoplay: false,
      },
      fireType: [
        {
          name: "火灾自动报警系统",
          icon: require("../../../assets/img/product/huozai.svg"),
        },
        {
          name: "消防水系统",
          icon: require("../../../assets/img/product/shui.svg"),
        },
        {
          name: "电气火灾系统",
          icon: require("../../../assets/img/product/huozai_1.svg"),
        },
        {
          name: "消防电源系统",
          icon: require("../../../assets/img/product/dianyuan.svg"),
        },
        {
          name: "气体灭火系统",
          icon: require("../../../assets/img/product/qiti.svg"),
        },
        {
          name: "应急照明系统",
          icon: require("../../../assets/img/product/zhaoming.svg"),
        },
        {
          name: "防排烟系统",
          icon: require("../../../assets/img/product/paifeng.svg"),
        },
        {
          name: "防火门及卷帘系统",
          icon: require("../../../assets/img/product/julian.svg"),
        },
      ],
      srcListArr: [
        { src: require("../../../assets/img/product/dhdt.png"), name: "导航地图" },
        {
          src: require("../../../assets/img/product/2D_2.5D.png"),
          name: "2 D/2.5D地图",
        },
        { src: require("../../../assets/img/product/3D.png"), name: "3D低保真地图" },
        {
          src: require("../../../assets/img/product/3Dg.png"),
          name: "3D高保真地图（BIM)",
        },
      ],
      mySwiper: null,
      activeIndex: -1,
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
    // this.mySwiper = this.$refs.mySwiper.swiper;
  },
  watch: {},
  methods: {
    showModel() {
      this.dialogVisible = true;
    },
    changeSlider(index) {
      this.activeIndex = index;
      this.mySwiper.slideTo(index, 1000, false); //切换到第index个slide，速度为1秒
    },
    touchchange(swipper) {
      this.activeIndex = swipper.activeIndex;
    },
  },
  components: {
    swiper,
    swiperSlide,
    Viewer,
    Common,
  },
};
</script>

<style scoped lang="scss">
#fire {
  .topPart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      color: #333333;
      margin-bottom: 1rem;
    }
    .intro {
      width: 80%;
      color: #999999;
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
  }
  .firstPart {
    padding: 5% 14%;
    .elRow {
      display: flex;
      flex-wrap: wrap;
      padding-top: 3rem;
    }
    .leftImg {
      width: 90%;
    }
    .rightInfo {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      width: 90%;
      align-items: center;
      .marginLeft {
        margin-left: 4rem;
      }
      .typeItem {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 1rem 2rem;
        box-shadow: 0px 3px 60px 0px rgba(186, 186, 186, 0.19);
        border-radius: 3rem;
        background: #ffffff;
        width: 22rem;
        height: 5rem;
        margin-right: 2rem;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
          transform: translate(0, -5px);
          transition: all 0.3s;
        }
        img {
          background: linear-gradient(
            125deg,
            rgba(0, 183, 164, 0.49),
            rgba(13, 202, 129, 0.49)
          );
          box-shadow: 0px 3px 60px 0px rgba(186, 186, 186, 0.19);
          border-radius: 15px;
          width: 3rem;
          height: 3rem;
          margin-right: 2rem;
        }
        .typeName {
          font-weight: 400;
          color: #696969;
          line-height: 2.6rem;
          font-size: 1.4rem;
        }
      }
    }
  }
  .middlePart{
      padding: 2% 0;
      background: url('../../../assets/img/product/show.png');
      background-size: 100% 100%;
      height: 60rem;
      .contentImg{
          width: 100%;
          padding: 0px 20%;
            height: 88%;
          img{
              width:100%;
              height: 100%;
          }
      }
  }
  .lastPart {
    padding: 5% 14%;
  }
  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../../assets/responsive/fire.scss";
</style>
